// extracted by mini-css-extract-plugin
export default {"animation-flash":"Cards_animation-flash__o0cLw","flash":"Cards_flash__OqSqI"};